import { createContext } from 'react';

const stateKey = (slug) => `guessaulenko-state-${slug}`;
const statsKey = (slug) => `guessaulenko-stats-${slug}`;

// One-time migration from pre-game-type flat keys → slug-keyed keys
const migrateStorage = () => {
	const oldState = localStorage.getItem('guessaulenko-state');
	const oldStats = localStorage.getItem('guessaulenko-stats');
	if (oldState && !localStorage.getItem(stateKey('classic'))) {
		localStorage.setItem(stateKey('classic'), oldState);
		localStorage.removeItem('guessaulenko-state');
	}
	if (oldStats && !localStorage.getItem(statsKey('classic'))) {
		localStorage.setItem(statsKey('classic'), oldStats);
		localStorage.removeItem('guessaulenko-stats');
	}
};

migrateStorage();

const StateContext = createContext({
	retrieveState: () => {},
	updateState: () => {},
	deleteState: () => {},
	retrieveStats: () => {},
	updateStats: () => {},
	deleteStats: () => {},
});

export const StateContextProvider = (props) => {
	const retrieveStateHandler = (slug) => {
		try { return JSON.parse(localStorage.getItem(stateKey(slug))); }
		catch { return null; }
	};
	const updateStateHandler = (slug, newState) => localStorage.setItem(stateKey(slug), JSON.stringify(newState));
	const deleteStateHandler = (slug) => localStorage.removeItem(stateKey(slug));

	const retrieveStatsHandler = (slug) => {
		try { return JSON.parse(localStorage.getItem(statsKey(slug))); }
		catch { return null; }
	};
	const updateStatsHandler = (slug, newStats) => localStorage.setItem(statsKey(slug), JSON.stringify(newStats));
	const deleteStatsHandler = (slug) => localStorage.removeItem(statsKey(slug));

	const contextValue = {
		retrieveState: retrieveStateHandler,
		updateState: updateStateHandler,
		deleteState: deleteStateHandler,
		retrieveStats: retrieveStatsHandler,
		updateStats: updateStatsHandler,
		deleteStats: deleteStatsHandler,
	};

	return <StateContext.Provider value={contextValue}>{props.children}</StateContext.Provider>;
};

export default StateContext;
